import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Config } from './config';
import { State } from '../Models/state';
import { Observable } from 'rxjs/Observable';
import { LanguageService } from './lang';


@Injectable()
export class StateService {

  constructor(private http: HttpClient,
              private config: Config,
              private languageService: LanguageService) { }

  list(): Observable<State[]> {
    // states depend on language hence the flatmap
    return this.languageService.getLanguage().flatMap(
      value => {
        return this.http.get<State[]>(this.config.getURL('states'));
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/Services/state.ts